import { render, staticRenderFns } from "./AddMembershipAffiliatePolicy.vue?vue&type=template&id=afa60f1e&"
import script from "./AddMembershipAffiliatePolicy.vue?vue&type=script&lang=js&"
export * from "./AddMembershipAffiliatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AddMembershipAffiliatePolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports